import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {AuthenticationGuard} from './oauth/authentication.guard';
import {APP_NAME, APP_NAME_MOBILE, HOME_PAGE} from './services/shared-data.service';
import {StorageService} from './services/storage.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {filter, Subject} from 'rxjs';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  year = new Date().getFullYear();
  title = APP_NAME;
  isMobile: boolean;
  userID: any;
  userIDLink: any;
  hiddenIndicator: boolean = true;
  origin: string;
  origin1: string;
  origin2: string;
  origin3: string;
  skipToMain: string;
  private readonly _destroying$ = new Subject<void>();
  private readonly isNavigating = false;

  constructor(private readonly router: Router, private readonly authService: AuthenticationGuard,
              private readonly storageService: StorageService,
              private readonly deviceService: DeviceDetectorService,
              private readonly msalService: MsalService,
              private readonly msalBroadcastService: MsalBroadcastService
              ) {
    this.isMobile = this.deviceService.isMobile();
    if (this.isMobile)
      this.title = APP_NAME_MOBILE;

    // MsalModule.forRoot() handles redirect automatically with MsalRedirectComponent
    // No need to manually call handleRedirectPromise
  }

  ngOnInit(): void {
    this.checkAccount(); // Get MSAL account and store username
    this.userHandler();  // Display the username
    
    this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.setSkipLinkUrl(event.urlAfterRedirects);
      });
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }

  private checkAccount(): void {
    const accounts = this.msalService.instance.getAllAccounts();
    if (accounts.length > 0) {
      this.msalService.instance.setActiveAccount(accounts[0]);
      const username = accounts[0].username;
      this.storageService.setItem('userId', username);
    }
  }

  private setSkipLinkUrl(currentUrl: string): void {
    if (!currentUrl.endsWith('#app-content')) {
      this.skipToMain = `${currentUrl}#app-content`;
    }
  }

  userHandler() {
    let idToken = this.storageService.getItem("userId");
    if (idToken) {
      // Sanitize user input to prevent XSS attacks while preserving email format
      const sanitizedUserId = idToken.replace(/[^a-zA-Z0-9@._-]/g, '').toLowerCase();
      this.userID = sanitizedUserId.split('@')[0].toUpperCase();
      this.userIDLink = "https://www.sdcds.ford.com/ldap.cgi?user=" + encodeURIComponent(sanitizedUserId);
      this.hiddenIndicator = false;
    }
  }

  logoClick() {
    this.router.navigate([HOME_PAGE]);
  }
}